import { Skeleton, Text } from 'ui/baseComponents'
import { DataTable } from 'ui/components/DataTable'
import { columns } from './configuration'
import { TEXT_FIELD_VARIANT } from 'ui/screens/Users/consts'
import { useUsers } from 'ui/hooks'
import { colors } from 'theme/colors'

/**
 * The table that displays the list of users in the organization.
 *
 * @returns {JSX.Element} The User Table
 */
const UserTable = () => {
  const { loading, data, error } = useUsers()

  const tableData = data?.map((user) => ({
    ...user,
    user, // Add the user object to the row data for the UserStatusToggle and UserTypeSwitch components
  }))

  const options = {
    filter: false,
    setRowProps: (rowData) => ({
      style: {
        backgroundColor: rowData[0].disabled // Grey out the row if the user is disabled
          ? colors.GREY[100]
          : colors.WHITE,
      },
    }),
    textLabels: {
      body: {
        noMatch: error ? (
          <Text variant={TEXT_FIELD_VARIANT}>Unable to load users</Text>
        ) : loading ? (
          <Skeleton width="100%" />
        ) : (
          <Text variant={TEXT_FIELD_VARIANT}>No users found</Text>
        ),
      },
    },
    viewColumns: false,
  }

  return <DataTable columns={columns} data={tableData} options={options} />
}

export default UserTable
